import { DependencyList, useMemo } from 'react';
import { computed, IComputedValueOptions } from 'mobx';

// useMemo used to give stable reference
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function useComputed<T>(func: () => T, options?: IComputedValueOptions<T>, deps?: DependencyList) {
    return useMemo(() => computed(func, options), deps ?? []).get();
}

export default useComputed;
